import {Add24Icon, Analytics24Icon, Settings24Icon, Playlist24Icon} from "@kaltura/ds-react-icons";

// link actions are based on old implementation in kms side, which includes label value and icon value
// since they are a simple link, only the icon is mapped
export const iconsMap = {
    "eventplatform-Settings": <Settings24Icon />,
    "v2ui-analytics-icon": <Analytics24Icon />,
    "icon-plus": <Add24Icon />,
    "v2ui-add-icon": <Playlist24Icon />
}
